import { GlobalSearchI } from '../interfaces/global_search.interface'
import { GlobalSearchService } from '../services/global_search.service'
import { GlobalSearchResponseT } from '../types/global_search.types'

const globalSearchService = new GlobalSearchService()

class GlobalSearchRealisation implements GlobalSearchI {
    async search(name: string): Promise<GlobalSearchResponseT> {
        return globalSearchService.search(name)
    }
}

export const global_search = new GlobalSearchRealisation()
